import { COMMA, ENTER } from '@angular/cdk/keycodes'
import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips'
import { MatFormFieldControl } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { isValidCPT } from '@mmx/shared'

import { CustomMaterialInputControlComponent } from '../custom-field'

@Component({
  selector: 'mmx-codes-selector',
  templateUrl: './codes-selector.component.html',
  providers: [
    {
      provide: MatFormFieldControl,
      useExisting: CodesSelectorInputComponent,
    },
  ],
  standalone: true,
  imports: [
    CommonModule,
    MatChipsModule,
    MatIconModule,
  ],
})
export class CodesSelectorInputComponent extends CustomMaterialInputControlComponent<string[]> {
  @Input()
  public validateCPT = true

  public get value() {
    return this._value || []
  }

  public set value(value: string[]) {
    super.value = (value || []).filter((item, i, self) => self.indexOf(item) === i)
  }

  public readonly separatorKeysCodes = [ENTER, COMMA]

  public removeCode(code: string) {
    this.value = this.value.filter((c) => c !== code)
  }

  public addCode(e: MatChipInputEvent) {
    if (this.validateCPT && !isValidCPT(e.value)) {
      return
    }

    this.value = Array.from(
      new Set([...this.value, (e.value || '').trim()]),
    )

    e.chipInput?.clear()
  }
}
